<div class="position-relative">
  <rask-button [disabled]="!handelssortimentRows?.length"
    class="ps-0 pe-0"
    color="tertiary"
  (click)="togglePopup($event)">Skapa förkalkylsmall</rask-button>
  @if (showPanel) {
    <div class="hs-as-mall-panel">
      <rask-input label="Mallnamn" [(ngModel)]="newMall.namn"></rask-input>
      <rask-button color="primary" (click)="saveAsMall($event)">Spara</rask-button>
      <rask-button color="secondary" (click)="abort($event)">Avbryt</rask-button>
      @if (validationContext) {
        <div class="feedback-panel">
          @for (error of validationContext.errors; track error) {
            <small class="text-danger">{{error}}</small>
          }
        </div>
      }
    </div>
  }
</div>